import { TRedesignStickyBarPhase } from './computeStickyBarPhase';

export type TRedesignStickyBarVariant = 'hidden' | 'info' | 'info-empty' | 'cta';

interface IResolveStickyBarVariantParams {
  phase: TRedesignStickyBarPhase;
  hasOffers: boolean;
  isResetButtonVisible: boolean;
  hasCalculatorErrors: boolean;
  isFetching: boolean;
}

export const resolveStickyBarVariant = ({
  phase,
  hasOffers,
  isResetButtonVisible,
  hasCalculatorErrors,
  isFetching,
}: IResolveStickyBarVariantParams): TRedesignStickyBarVariant => {
  if (hasCalculatorErrors || phase === 'afterOffers' || isFetching) {
    return 'hidden';
  }

  if (phase === 'onOffers' && hasOffers) {
    return 'cta';
  }

  if (!hasOffers) {
    if (isResetButtonVisible) {
      return 'hidden';
    }

    return 'info-empty';
  }

  if (phase === 'beforeOffers') {
    return 'info';
  }

  return 'hidden';
};
